/*
 * @Author: yanghailong
 * @Date: 2024-07-11 11:04:14
 * @Last Modified by: yanghailong
 * @Last Modified time: 2024-10-18 18:02:50
 */

export default [
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import('../pages/404.vue'),
  },
  {
    path: "/login",
    name: 'Login',
    component: () => import('../pages/login/index.vue'),
  },
  {
    path: "/",
    name: "Layout",
    component: () => import('../layout/index.vue'),
    children: [
      {
        path: "",
        component: () => import('../pages/home/index.vue'),
        name: "Home",
        meta: {
          name: '首页'
        },
      },
      {
        path: "/ess",
        component: () => import('../pages/ess/index.vue'),
        name: "Ess",
        meta: {
          name: "储能系统",
        },
      },
      {
        path: "/pv",
        component: () => import('../pages/pv/index.vue'),
        meta: {
          name: "光伏",
        },
      },
      {
        path: "/et",
        component: () => import('../pages/wt/index.vue'),
        meta: {
          name: "风电",
        },
      },
      {
        path: "/analysis",
        component: () => import('../pages/analysis/index.vue'),
        redirect: "/analysis/dashboard",
        children: [
          {
            path: "dashboard",
            component: () => import('../pages/analysis/dashboard/index.vue'),
            meta: {
              name: "数据分析",
            },
          },
          {
            path: "download",
            component: ()=> import('../pages/analysis/download/index.vue'),
            meta: {
              name: "数据下载",
            },
          },
          {
            path: "graph",
            component: () => import('../pages/analysis/graph/index.vue'),
            meta: {
              name: "数据图表",
            },
          },
        ],
        meta: {
          name: "数据分析",
        },
      },
      {
        path: "/alarm",
        component: () => import('../pages/alarm/index.vue'),
        name: "Alarm",
        children: [
          {
            path: "total",
            component: () => import('../pages/alarm/total/index.vue'),
            name: "AlarmTotal",
            meta: {
              name: "告警总览",
            },
          },
          {
            path: "history",
            component: () => import('../pages/alarm/history/index.vue'),
            meta: {
              name: "告警历史",
            },
          },
          {
            path: "details/:alarmCode",
            component: () => import('../pages/alarm/details/index.vue'),
            props: true,
            meta: {
              name: "告警历史",
            },
          },
        ],
        meta: {
          name: "告警",
        },
      },
      {
        path: "/settings",
        component: () => import('../pages/settings/index.vue'),
        meta: {
          name: "设置",
        },
      },
    ],
  },
];
